(function () {
  'use strict';

  function parseQty(raw) {
    var digits = String(raw == null ? '' : raw).replace(/\D/g, '');
    if (digits === '') return null;
    var val = parseInt(digits, 10);
    return isNaN(val) ? null : val;
  }

  function clampQty(val, minQty) {
    return Math.max(minQty, val);
  }

  function querySelector(selector, root) {
    if (!selector) return null;
    if (selector.charAt(0) === '#' || selector.charAt(0) === '.') {
      return (root && root.querySelector ? root : document).querySelector(selector);
    }
    return root && root.querySelector ? root.querySelector(selector) : document.querySelector(selector);
  }

  window.vfInitQtyStepper = function (options) {
    if (!options) return null;

    var root = options.root || document;
    var minQty = options.minQty != null ? options.minQty : 1;
    var qtyInput = options.qtyInput;

    if (!qtyInput && options.qtyInputSelector) {
      qtyInput = querySelector(options.qtyInputSelector, root);
    }
    if (!qtyInput && options.qtyInputId) {
      qtyInput = document.getElementById(options.qtyInputId);
    }
    if (!qtyInput) return null;

    if (options.minQty == null && qtyInput.dataset.minQty) {
      minQty = parseInt(qtyInput.dataset.minQty, 10) || minQty;
    }

    var qtyDecBtn = options.qtyDecBtn || querySelector(options.qtyDecSelector, root);
    var qtyIncBtn = options.qtyIncBtn || querySelector(options.qtyIncSelector, root);
    var onUpdate = typeof options.onUpdate === 'function' ? options.onUpdate : function () {};

    function getQty() {
      var parsed = parseQty(qtyInput.value);
      return clampQty(parsed == null ? minQty : parsed, minQty);
    }

    function syncButtons(val) {
      if (qtyDecBtn) {
        qtyDecBtn.disabled = val <= minQty;
        if (options.onMinusOpacity) {
          qtyDecBtn.style.opacity = val <= minQty ? '0.35' : '1';
        }
      }
    }

    function commitQty(val) {
      val = clampQty(val, minQty);
      qtyInput.value = String(val);
      syncButtons(val);
      onUpdate(val);
      return val;
    }

    if (qtyDecBtn) {
      qtyDecBtn.addEventListener('click', function () {
        commitQty(getQty() - 1);
      });
    }

    if (qtyIncBtn) {
      qtyIncBtn.addEventListener('click', function () {
        commitQty(getQty() + 1);
      });
    }

    qtyInput.addEventListener('focus', function () {
      window.setTimeout(function () {
        qtyInput.select();
      }, 0);
    });

    qtyInput.addEventListener('input', function () {
      var parsed = parseQty(qtyInput.value);
      if (parsed == null) {
        syncButtons(minQty);
        return;
      }
      syncButtons(clampQty(parsed, minQty));
      onUpdate(clampQty(parsed, minQty));
    });

    qtyInput.addEventListener('blur', function () {
      commitQty(getQty());
    });

    qtyInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        commitQty(getQty());
        qtyInput.blur();
      }
    });

    qtyInput.addEventListener('change', function () {
      commitQty(getQty());
    });

    commitQty(getQty());

    return {
      getQty: getQty,
      setQty: commitQty,
      minQty: minQty
    };
  };
})();
